<template>
     <vs-dialog v-model="active">
        <template #header>
          <h4 class="not-margin">
            Cancelar {{ row.categoria === 'descuento' ? 'descuento' : row.categoria === 'beca' ? 'beca' : 'pago'}}
          </h4>
        </template>
        <div class="con-form">
          <vs-row>
            <vs-col vs-justify="center" vs-align="center" w="12">
              <center> 
                <h6>¿Seguro que deseas cancelar {{ row.categoria === 'descuento' ? 'el descuento' : row.categoria === 'beca' ? 'la beca' :'el pago'}}?</h6>
              </center>
            </vs-col>
          </vs-row>
        </div>
        <template #footer>
          <div class="footer-dialog" style="display:flex;">  
            <vs-button block danger class="color-red" @click="close">
              Cancelar
            </vs-button>
            <vs-button block success @click="cancelarPago(row.movimiento_id, row.categoria)">
              Aceptar
            </vs-button>          
          </div>
        </template>
      </vs-dialog>
</template>

<script>
import profesor from '../../../../api/requests/landing-profesor.js'

export default {
    props:[
      'value',
      'row',
      'personaId',
      'cicloEscolar',
      'institucion',
    ],
    data () {
        return {
            active: false,
        }
    },
    methods: {
      async cancelarPago (id, categoria) {
        const loading = this.$vs.loading()
        try {
          let typeCategory = ''
          if(categoria === 'descuento'){
            typeCategory = 'descuento'
          }else if (categoria === 'beca'){
            typeCategory = 'beca'
          } else {
            typeCategory = 'pago'
          }

          const formData = new FormData();
          formData.append('pago', id)
          formData.append('tipo', typeCategory)
          const response = await profesor.postSelectPagos(typeCategory, formData)
          if(response.data.response[0].status === 200){
            loading.close()
            this.$vs.notification({
                progress: 'auto',
                color: 'success',
                position: null,
                title: 'Operación éxitosa'
            })
          }else{
            loading.close()
            this.$vs.notification({
              progress: 'auto',
              color: 'danger',
              position: null,
              title: 'Error',
              text: 'Algo salió mal'
            })
          }
          this.$emit('refreshTable',true)
          this.active = false
        } catch(error) {
            loading.close()
            const response = error.response.data
                  if (response && response.errores){
      			        const data = response.errores
				            let mensajes = Object.values(data)
                    if (Array.isArray(mensajes)){
                      mensajes.forEach(element => {
                          this.$vs.notification({
                            duration: 5000,
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: element 
                          })
                        
                      });
                    }else if (mensajes.descripcion){
                      this.$vs.notification({
                          duration: 5000,
                          progress: 'auto',
                          color: 'danger',
                          position: null,
                          title: 'Error',
                          text: mensajes.descripcion 
                      })
					
                      }else {
                          this.$vs.notification({
                            progress: 'auto',
                            duration: 5000,
                            color: 'warn',
                            position: null,
                            title: 'Warning',
                            text: `Algo salió mal`
                          })
                      }
      		      }
        }
      },
      async close () {
        this.active = false
      }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>

<style lang="scss"  scoped >
.color-blue {
  background-color: #005aa3;
}
</style>